import React, { useContext } from 'react';
import localization from '../../../constants/localization';

const SelectAllSelectNoneButton = ({
  selectAllRead,
  selectAllWrite,
  selectNoneRead,
  selectNoneWrite,
  group,
}) => {
  const LS = useContext(localization);
  return (
    <div style={{ display: 'flex' }}>
      <button type='button' onClick={selectAllRead}>
        <i className="fa fa-plus-square-o" /> {group} {LS.manageGroups.readSelectAll}
      </button>

      <button type='button' className="remove-action" onClick={selectNoneRead}>
        <i className="fa fa-times" /> {group} {LS.manageGroups.readSelectNone}
      </button>

      <button type='button' onClick={selectAllWrite}>
        <i className="fa fa-plus-square-o" /> {group} {LS.manageGroups.writeSelectAll}
      </button>

      <button type='button' className="remove-action" onClick={selectNoneWrite}>
        <i className="fa fa-times" /> {group} {LS.manageGroups.writeSelectNone}
      </button>
    </div>
  );
};

export default SelectAllSelectNoneButton;
